/**
 * AppLoader Component
 * 
 * A stunning full-screen loading state with the ProcessingOrb,
 * floating particles, and elegant branding.
 */

import React from 'react';
import { ProcessingOrb } from './ProcessingOrb';

interface AppLoaderProps {
    /** Optional loading message */
    message?: string;
}

export function AppLoader({ message }: AppLoaderProps) {
    return (
        <div className="app-loading-screen" aria-busy="true" role="status">
            {/* Animated background particles */}
            <div className="app-loader-particles">
                {Array.from({ length: 20 }).map((_, i) => (
                    <div
                        key={i}
                        className="loader-particle"
                        style={{
                            '--particle-index': i,
                            '--particle-x': `${Math.random() * 100}%`,
                            '--particle-delay': `${Math.random() * 5}s`,
                            '--particle-duration': `${8 + Math.random() * 12}s`,
                            '--particle-size': `${2 + Math.random() * 4}px`,
                        } as React.CSSProperties}
                    />
                ))}
            </div>

            {/* Glowing rings behind orb */}
            <div className="app-loader-rings">
                <div className="loader-ring loader-ring-1" />
                <div className="loader-ring loader-ring-2" />
                <div className="loader-ring loader-ring-3" />
            </div>

            {/* Main content */}
            <div className="app-loader-content">
                {/* The ProcessingOrb */}
                <div className="app-loader-orb-container">
                    <ProcessingOrb size={120} />
                </div>

                {/* Brand name with shimmer effect */}
                <div className="app-loader-brand">
                    <span className="app-loader-brand-text">StudNote</span>
                </div>

                {/* Loading message */}
                {message && (
                    <p className="app-loader-message">{message}</p>
                )}

                {/* Loading dots */}
                <div className="app-loader-dots">
                    <span className="loader-dot" />
                    <span className="loader-dot" />
                    <span className="loader-dot" />
                </div>
            </div>
        </div>
    );
}
